import { MtDriveFile, MtDriveFolder, MtDriveVersion } from "server/models"
import { OrderType, StateType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setDrivePath = (path: readonly MtDriveFolder[]) => ({
    type: inferLiteral(types.DRIVE_PATH),
    path,
})
export const setDriveBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.DRIVE_BASE_ROUTE),
    baseRoute,
})
export const setDriveOutsideMode = (outsideMode: boolean) => ({
    type: inferLiteral(types.DRIVE_OUTSIDE_MODE),
    outsideMode,
})
export const setDriveOnSelectFile = (onSelect: types.DriveOnSelectFile) => ({
    type: inferLiteral(types.DRIVE_ON_SELECT_FILE),
    onSelect,
})
export const setDriveOnSelectFiles = (onSelect: types.DriveOnSelectFiles) => ({
    type: inferLiteral(types.DRIVE_ON_SELECT_FILES),
    onSelect,
})
export const setDriveOnSelectVersion = (onSelect: types.DriveOnSelectVersion) => ({
    type: inferLiteral(types.DRIVE_ON_SELECT_VERSION),
    onSelect,
})
export const setDriveListStyle = (listStyle: types.DriveListStyle) => ({
    type: inferLiteral(types.DRIVE_LIST_STYLE),
    listStyle,
})
export const setDriveSortColumn = (sortColumn: types.DriveSort) => ({
    type: inferLiteral(types.DRIVE_SORT_COLUMN),
    sortColumn,
})
export const setDriveSortOrder = (sortOrder: OrderType) => ({
    type: inferLiteral(types.DRIVE_SORT_ORDER),
    sortOrder,
})
export const setDriveFilters = (filters: types.DriveFilters) => ({
    type: inferLiteral(types.DRIVE_FILTERS),
    filters,
})
export const setDriveSearchState = (searchState: StateType) => ({
    type: inferLiteral(types.DRIVE_SEARCH_STATE),
    searchState,
})
export const setDrivePopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.DRIVE_POPUP_MENU_SHOW),
    show,
})
export const setDrivePopupMenu = (target: HTMLElement, placement: types.DriveMenuPlacement) => ({
    type: inferLiteral(types.DRIVE_POPUP_MENU),
    target,
    placement,
})
export const setDriveAction = (action: types.DriveActionType) => ({
    type: inferLiteral(types.DRIVE_ACTION),
    action,
})

// upload file list
export const setDriveUploadFileList = (uploadFileList: types.NewFile[]) => ({
    type: inferLiteral(types.DRIVE_UPLOAD_FILE_LIST),
    uploadFileList,
})
export const setDriveUploadFileListStatus = (index: number, status: types.NewFileStatusType) => ({
    type: inferLiteral(types.DRIVE_UPLOAD_FILE_LIST_STATUS),
    index,
    status,
})

// folders
export const setDriveFolderList = (folders: readonly types.DriveFolder[]) => ({
    type: inferLiteral(types.DRIVE_FOLDER_LIST),
    folders,
})
export const setDriveFolderListEmpty = (empty: boolean) => ({
    type: inferLiteral(types.DRIVE_FOLDER_LIST_EMPTY),
    empty,
})
export const setDriveFolderActive = (active: types.DriveFolder) => ({
    type: inferLiteral(types.DRIVE_FOLDER_ACTIVE),
    active,
})
export const setDriveFolderSelected = (selected: readonly types.DriveFolder[]) => ({
    type: inferLiteral(types.DRIVE_FOLDER_SELECTED),
    selected,
})
export const setDriveFolderReloadList = (value: boolean) => ({
    type: inferLiteral(types.DRIVE_FOLDER_RELOAD_LIST),
    value,
})
export const setDriveFolderListLoadState = (loadState: StateType) => ({
    type: inferLiteral(types.DRIVE_FOLDER_LIST_LOAD_STATE),
    loadState,
})

// files
export const setDriveFileList = (files: readonly types.DriveFile[]) => ({
    type: inferLiteral(types.DRIVE_FILE_LIST),
    files,
})
export const setDriveFileListEmpty = (empty: boolean) => ({
    type: inferLiteral(types.DRIVE_FILE_LIST_EMPTY),
    empty,
})
export const setDriveFileEdit = (file: MtDriveFile) => ({
    type: inferLiteral(types.DRIVE_FILE_EDIT),
    file,
})
export const setDriveFileActive = (active: types.DriveFile) => ({
    type: inferLiteral(types.DRIVE_FILE_ACTIVE),
    active,
})
export const setDriveFileSelected = (selected: readonly types.DriveFile[]) => ({
    type: inferLiteral(types.DRIVE_FILE_SELECTED),
    selected,
})
export const setDriveFileOffset = (offset: number) => ({
    type: inferLiteral(types.DRIVE_FILE_OFFSET),
    offset,
})
export const setDriveFileLoadMore = (loadMore: boolean) => ({
    type: inferLiteral(types.DRIVE_FILE_LOAD_MORE),
    loadMore,
})
export const setDriveFileReloadList = (value: boolean) => ({
    type: inferLiteral(types.DRIVE_FILE_RELOAD_LIST),
    value,
})
export const setDriveFileReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.DRIVE_FILE_RELOAD_EDIT),
    value,
})
export const setDriveFileListLoadState = (loadState: StateType) => ({
    type: inferLiteral(types.DRIVE_FILE_LIST_LOAD_STATE),
    loadState,
})

// versions
export const setDriveVersionList = (versions: types.VersionList) => ({
    type: inferLiteral(types.DRIVE_VERSION_LIST),
    versions,
})
export const setDriveVersionIds = (versionIds: readonly number[]) => ({
    type: inferLiteral(types.DRIVE_VERSION_IDS),
    versionIds,
})
export const setDriveVersionEdit = (version: MtDriveVersion) => ({
    type: inferLiteral(types.DRIVE_VERSION_EDIT),
    version,
})
export const setDriveVersionSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.DRIVE_VERSION_SELECTED),
    selected,
})
export const setDriveVersionSort = (
    sortColumn: keyof MtDriveVersion,
    sortOrder: OrderType,
) => ({
    type: inferLiteral(types.DRIVE_VERSION_SORT),
    sortColumn,
    sortOrder,
})
export const setDriveVersionFilters = (filters: types.DriveVersionFilters) => ({
    type: inferLiteral(types.DRIVE_VERSION_FILTERS),
    filters,
})
export const setDriveVersionReloadList = (value: boolean) => ({
    type: inferLiteral(types.DRIVE_VERSION_RELOAD_LIST),
    value,
})
export const setDriveVersionReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.DRIVE_VERSION_RELOAD_EDIT),
    value,
})
